<article class="container">
  <header>
    <img *ngIf="message.icon" class="icon" [src]="message.icon" alt="Message icon">
    <h2 class="heading">{{ message.subject }}</h2>
  </header>
  <section class="body">
    <div [innerHTML]="message.body | safePureHtml"></div>

    <mat-checkbox
      *ngIf="message.dismissable"
      class="checkbox"
      color="primary"
      [(ngModel)]="isAcknowledged"
      (ngModelChange)="updateCanConfirm()"
    >
      I acknowledge
    </mat-checkbox>
  </section>

  <footer class="footer" #footerElement>
    <button
      mat-flat-button
      color="primary"
      class="footer__action"
      [disabled]="!canConfirm"
      [attr.tabindex]="canConfirm ? 0 : -1"
      (click)="onOkClick()"
    >
      OK
    </button>
  </footer>
</article>
